var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-prop-default"},[_vm._t("default",null,{"list":_vm.list})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }